import moment from 'moment';
import _ from 'lodash';
import formatCurrency from 'format-currency';

class ChargecodeReportController {
  constructor($rootScope, $uibModal, $state, $http) {
    "ngInject";
    this.state = $state;
    this.$http = $http;
    this.queryResult;
    this.$rootScope = $rootScope;
    this.customerFilter = 'all';
    this.contractFilter = 'all';
    this.taskFilter = 'all';
    this.formatCurrency = formatCurrency;


    let self = this;
    this.$http.get(this.baseUrl+name)

    this.$http.get($rootScope.apiHost+"/api/reports/timebychargecode", {withCredentials: true}).then(function (success) {
      self.report = success.data;
      self.queryParams = self.report.filterParameters;
      self.queryParams.dateRange = {
        name: "dateRange",
        value: "thisYear"
      };

      self.search();
    });


    this.opened = {};
    this.open = function($event, elementOpened) {
      $event.preventDefault();
      $event.stopPropagation();
      self.opened[elementOpened] = !self.opened[elementOpened];
    };

    this.datePickerFormat = 'MMM dd, yyyy';
    this.dateOptions = {
      // dateDisabled: disabled,
      formatYear: 'yy',
      maxDate: new Date(2020, 5, 22),
      minDate: new Date(1999,1,1),
      startingDay: 1
    };
  }

  search() {
    let self = this;
    self.queryResult = [];

    if(this.queryParams.dateRange.value === 'custom') {

      if(this.queryParams.startDate.value == 'default') {
        this.queryParams.startDate.value = moment().startOf("month");
      }

      if(this.queryParams.endDate.value == 'default') {
        this.queryParams.endDate.value = moment().endOf("month");
      }

      this.queryParams.startDate.value.setHours(0);
      this.queryParams.startDate.value.setMinutes(0);
      this.queryParams.startDate.value.setSeconds(0);
      this.queryParams.startDate.value.setMilliseconds(0);

      this.queryParams.endDate.value.setHours(0);
      this.queryParams.endDate.value.setMinutes(0);
      this.queryParams.endDate.value.setSeconds(0);
      this.queryParams.endDate.value.setMilliseconds(0);


    }

    this.$http.post(this.$rootScope.apiHost+"/api/reports/timebychargecode", this.queryParams, {withCredentials: true}).then(function (success) {
      self.queryResult = success.data;
    });
  }



  currency(value) {
    return formatCurrency(value);
  }

  getTotalHours() {
    let totalHours = 0;
    if(this.queryResult) {
      this.queryResult.forEach(function (result) {
        totalHours = totalHours + result.hours;
      });
    }

    return totalHours;
  }






}

export default ChargecodeReportController;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/chargecode-report/chargecode-report.controller.js